import type { SimulatorTab } from "@/types/api";
import { request } from "./transport";

export interface SimulatorTabInput {
  ticker: string;
  layers: unknown[];
  scenario?: Record<string, unknown> | null;
  pinned?: boolean;
  position?: number;
  saved_strategy_id?: string | null;
  /** ISO timestamp to soft-archive the tab (close it without deleting),
   *  or `null` to restore it. Mirrors legacy `templates.archived_at`. */
  archived_at?: string | null;
}

export const simulatorTabs = {
  listSimulatorTabs: () =>
    request<{ simulator_tabs: SimulatorTab[] }>("/simulator_tabs"),

  createSimulatorTab: (input: SimulatorTabInput) =>
    request<{ simulator_tab: SimulatorTab }>("/simulator_tabs", {
      method: "POST",
      body: JSON.stringify({ simulator_tab: input }),
    }),

  updateSimulatorTab: (id: string, patch: Partial<SimulatorTabInput>) =>
    request<{ simulator_tab: SimulatorTab }>(`/simulator_tabs/${id}`, {
      method: "PATCH",
      body: JSON.stringify({ simulator_tab: patch }),
    }),

  deleteSimulatorTab: (id: string) =>
    request<{ ok: true }>(`/simulator_tabs/${id}`, { method: "DELETE" }),

  reorderSimulatorTabs: (ids: string[]) =>
    request<{ simulator_tabs: SimulatorTab[] }>("/simulator_tabs/reorder", {
      method: "POST",
      body: JSON.stringify({ ids }),
    }),

  batchCreateSimulatorTabs: (inputs: SimulatorTabInput[]) =>
    request<{ simulator_tabs: SimulatorTab[] }>(
      "/simulator_tabs/batch_create",
      {
        method: "POST",
        body: JSON.stringify({ simulator_tabs: inputs }),
      },
    ),

  batchUpdateSimulatorTabs: (
    updates: ({ id: string } & Partial<SimulatorTabInput>)[],
  ) =>
    request<{ simulator_tabs: SimulatorTab[] }>(
      "/simulator_tabs/batch_update",
      {
        method: "PATCH",
        body: JSON.stringify({ updates }),
      },
    ),

  batchDestroySimulatorTabs: (ids: string[]) =>
    request<{ ok: true; deleted: number }>("/simulator_tabs/batch_destroy", {
      method: "DELETE",
      body: JSON.stringify({ ids }),
    }),
};
